"use client";

import { ConfirmationModal } from "@/components/modal/modalConfirmation.component";
import { Text } from "@/components/text/text.component";
export const ProductReplaceKitModal = ({
  ref,
  formId = "product-form",
  onConfirm,
}: ProductReplaceKitModalProps) => {
  return (
    <ConfirmationModal
      confirmationLabel="Replace kit"
      ref={ref}
      onConfirm={() => {
        if (onConfirm) onConfirm();
        // Get product form
        const productForm = document.getElementById(formId) as HTMLFormElement;
        // Submit product form
        productForm?.requestSubmit();
      }}>
      <div className="flex flex-col gap-4">
        <Text variant="h6" className="text-center">
          You already have a kit in your cart.
        </Text>
        <Text className="text-center">
          You can only have one kit in your cart at a time. Would you like to
          replace your current kit with this one?
        </Text>
      </div>
    </ConfirmationModal>
  );
};

export type ProductReplaceKitModalProps = {
  ref: React.RefObject<HTMLDialogElement | null>;
  formId?: string;
  onConfirm?: () => void;
};
